import styled from '@emotion/styled'

import InternalError from './InternalError'
import NotFoundError from './NotFound'

const ErrorContentStyles = styled.main({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '7vw 0',
})

interface Props {
  errorCode: number
  refreshUrl?: string
}

const ErrorContent = ({ errorCode, refreshUrl }: Props) => (
  <ErrorContentStyles>
    {errorCode >= 500 && <InternalError refreshUrl={refreshUrl || ''} />}
    {errorCode < 500 && <NotFoundError />}
  </ErrorContentStyles>
)

export default ErrorContent
